<div class="modal">
  <div class="status-dialog-container">
    <h1><span> Instruções para realizar uma Importação em lote </span></h1>

    <div class="right-container">
      <div>
        <span class="warning">ATENÇÃO</span> <br />
        <span class="caution-text text">O arquivo utilizado para realizar a manuntenção, <b>deverá conter no máximo 50 mil beneficiários </b> </span>
      </div>

      <div>
        <span class="title">Manutenção em Lote</span>
        <span class="text">Cada linha do arquivo, refere-se à um beneficiário (seja ele titular ou dependente)</span>
      </div>

      <div>
        <span class="title">Tipos de Usuários </span>
        <span class="text">Em "Tipo" será informado se é Titular (T) ou Dependente (D)</span>
      </div>
    </div>
    <img (click)="close()" class="close-dialog" src="./assets/icons/gray-close-icon.svg" />
  </div>
</div>
